import React from 'react'
import styles from './ContentOpenNavStatic.less'
import { sh, ReduxWrapper, compose, buildPropTypes, pt } from 'common-data/datahelpers'
import _ from 'common-tools/LodashHelper'
import { Collapse, Navbar, NavbarToggler, Nav, NavItem } from 'reactstrap'
export class ContentOpenNavStaticPlain extends React.Component {
  constructor (props) {
    super(props)

    const { initialNav } = this.props

    this.state = {
      collapsed: true,
      activeNav: initialNav || ''
    }
  }

  static propTypes = buildPropTypes([
  ], {
    navs: pt.arrayOf(pt.shape({
      text: pt.string,
      permissions: pt.arrayOf(pt.string)
    })),
    initialNav: pt.string,
    onNavigate: pt.func
  })

  static defaultProps = {
    navs: [],
    initialNav: ''
  }

  toggleNavbar () {
    this.setState({
      collapsed: !this.state.collapsed
    })
  }

  onNavigate (text) {
    const { onNavigate } = this.props
    this.setState({
      activeNav: text
    }, () => {
      if (_.isFunction(onNavigate)) {
        onNavigate(text)
      }
    })
  }

  renderNavs (navs) {
    const { SessionAccount, SessionUser } = this.props
    const { activeNav } = this.state

    if (_.isArray(navs) === false) {
      return <Nav className='ml-auto' navbar />
    }

    const allowedNavs = _.filter(navs, (nav) => {
      if (_.isArray(nav.permissions)) {
        return SessionAccount.HasPermissions(nav.permissions) || SessionUser.HasPermissions(nav.permissions)
      } else {
        return true
      }
    })

    return <Nav className='ml-auto' navbar>
      {_.map(allowedNavs, (n, i) => {
        return (
          <NavItem key={i}>
            <span>
              <a href='#' className={`${styles.nav} ${activeNav === n.text ? styles.navSelected : ''}`} onClick={this.onNavigate.bind(this, n.text, n.onClick) }>{n.text}</a>
            </span>
          </NavItem>
        )
      })}
    </Nav>
  }

  render () {
    const { navs } = this.props

    return (
      <div className={styles.root}>
        <Navbar color='faded' light expand='md'>
          <NavbarToggler onClick={this.toggleNavbar} className='mr-2' />
          <Collapse isOpen={!this.state.collapsed} navbar>
            {this.renderNavs(navs)}
          </Collapse>
        </Navbar>
      </div>
    )
  }
}

export const ContentOpenNavStatic = compose(
  ReduxWrapper([
    sh.SessionAccount,
    sh.SessionUser
  ])
)(ContentOpenNavStaticPlain)
